import React from 'react';
import { Button } from './Button';
import { Shield } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-[90vh] flex items-center pt-20 pb-16 overflow-hidden bg-[#0a0e27]" data-id="element-94">
      {/* Mystical Background Gradients */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl" data-id="element-95">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-yellow-500/10 rounded-full blur-[120px] mix-blend-screen" data-id="element-96"></div>
        <div className="absolute bottom-1/4 right-1/4 w-[500px] h-[500px] bg-blue-600/10 rounded-full blur-[150px] mix-blend-screen" data-id="element-97"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-98">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-99">
          {/* Text Content */}
          <div className="text-center lg:text-left" data-id="element-100">
            <div className="inline-flex items-center space-x-2 bg-yellow-500/10 border border-yellow-500/30 rounded-full px-4 py-2 mb-6" data-id="element-101">
              <Shield className="w-4 h-4 text-yellow-400" data-id="element-102" />
              <span className="text-yellow-400 text-sm font-semibold tracking-wide uppercase" data-id="element-103">
                Protocolo de 72 Horas
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white leading-tight mb-6" data-id="element-104">
              GUÍA MAESTRA DE <br className="hidden lg:block" data-id="element-105" />
              <span className="bg-gradient-to-r from-yellow-200 via-yellow-400 to-yellow-600 bg-clip-text text-transparent" data-id="element-106">
                LIBERACIÓN Y PROTECCIÓN ENERGÉTICA
              </span>
              <br className="hidden lg:block" data-id="element-107" /> EN 3 DÍAS
            </h1>

            <h2 className="text-xl md:text-2xl text-gray-300 font-medium mb-8 leading-relaxed" data-id="element-108">
              Cómo detectar, cortar y protegerte de magia negra, entidades y
              ataques energéticos con un método paso a paso.
            </h2>

            <div className="bg-[#1a1f3a]/80 border-l-4 border-yellow-500 p-6 rounded-r-xl mb-8 backdrop-blur-sm" data-id="element-109">
              <p className="text-gray-200 text-lg leading-relaxed" data-id="element-110">
                Si has llegado hasta aquí, es porque sientes que algo "no está
                bien". Esa pesadez en la nuca que no te deja dormir, esa racha
                de mala suerte que parece no tener fin, o esa sensación de que
                por más que te esfuerzas, algo invisible te frena.
              </p>
              <p className="text-yellow-400 font-semibold mt-4" data-id="element-111">
                No es sugestión. Es una alteración real de tu campo energético.
                Y la buena noticia es que no necesitas meses para resolverlo.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start" data-id="element-112">
              <Button size="lg" href="#pricing-cta" className="w-full sm:w-auto" data-id="element-113">
                ¡SÍ, QUIERO LIBERAR MI ENERGÍA AHORA!
              </Button>
            </div>
          </div>

          {/* Product Image */}
          <div className="relative mx-auto w-full max-w-lg lg:max-w-none" data-id="element-114">
            <div className="absolute inset-0 bg-gradient-to-tr from-yellow-500/20 to-transparent rounded-full blur-3xl" data-id="element-115"></div>
            <img src="https://cdn.magicpatterns.com/uploads/325tgpcV64qdJAf2eUwRsf/High-end_product_mockup_202603261604.png" alt="Guía Maestra de Liberación y Protección Energética" className="relative z-10 w-full h-auto drop-shadow-[0_0_30px_rgba(212,175,55,0.3)] animate-[pulse_4s_ease-in-out_infinite]" data-id="element-116" />
          </div>
        </div>
      </div>
    </section>;
}